//helper function to check whether the current viewport matches the given breakpoint
const isBelowBreakpoint = (breakpoint) =>
  window.matchMedia(`(max-width: ${breakpoint})`).matches;

export { isBelowBreakpoint };
